const InputFieldBadge = ({
  badgeText,
  badgeValue,
  isValid,
  right = '12px',
}: {
  badgeText: string;
  badgeValue: string | number;
  isValid: boolean;
  right?: string;
}) => {
  // rendering input field badge component here
  return (
    <p
      style={{ right }}
      className={`absolute top-1/2 -translate-y-1/2 rounded-md font-medium py-1 px-2 text-base-white text-xs ${
        isValid ? 'bg-base-cyan' : 'bg-base-red'
      }`}
    >
      {badgeText}
      <span className='font-semibold'>{badgeValue}</span>
    </p>
  );
};

export default InputFieldBadge;
